"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CurrSc = void 0;
// ---------- import Packs
var react_1 = __importDefault(require("react"));
var condWeb_1 = require("./WebRoute/condWeb");
// ---------- import Internals
var WebRoute_1 = require("./WebRoute");
// ----------- export Component
var CurrSc = function (_a) {
    var info = _a.info;
    // ----------- set Props
    var sttRoutesInfo = info.sttRoutesInfo, passChanges = info.passChanges;
    // ----------- set Hooks
    var sttSelected = passChanges.sttSelected, setRouteData = passChanges.setRouteData;
    // ----------- set Data
    var CurrRoute = sttRoutesInfo[sttSelected];
    var infoWeb = { CurrRoute: CurrRoute, setRouteData: setRouteData };
    var WebComp = function () { return (0, WebRoute_1.WebRoute)(infoWeb); };
    var CurrComponent = function () { return CurrRoute; };
    var Component = (0, condWeb_1.condWeb)() ? WebComp() : CurrComponent();
    var CondComp = Component ? Component.component() : react_1["default"].createElement(react_1["default"].Fragment, null);
    return CondComp;
};
exports.CurrSc = CurrSc;
